import Vue from "vue";
export default Vue.extend({
    data: function () {
        return {
            year: new Date().getFullYear(),
        };
    },
});
